@use '@/sass/variables';

.search_select {
  &__error {
    border: 2px solid variables.$red !important;
  }
}
